import { OtherDocumentRepository} from "../domain/OtherDocumentRepository";
import { query_dispatcher_get, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { Folder } from "../domain/Folder";
import { Document } from "../domain/DocumentClass";
import { arg } from "mathjs";


export class ApiOtherDocumentRepository implements OtherDocumentRepository{
    
    query_dispatcher: QueryDispatcher
    sync_command_dispatcher: CommandDispatcher
    async_command_dispatcher: CommandDispatcher
    constructor() {
        this.query_dispatcher = query_dispatcher_get
        this.sync_command_dispatcher = sync_command_dispatcher
        this.async_command_dispatcher = async_command_dispatcher
    }

    async getUserPermissions(args):Promise<Object>{
        try{
            return await this.query_dispatcher.dispatch('get.role.permissions', args)
        }catch(error){
            console.log(error)
            return null
        }
    }
    
    async get_documents(args: any): Promise<any> {
        try {
            let res = await this.query_dispatcher.dispatch('filtered.documents', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async get_document_url(id){
        let res = await this.query_dispatcher.dispatch('get.other.doc.url', { doc_id: id })
        return res.url
    }

    async get_cropped_document_url(id: any): Promise<string> {
        try {
            let res = await this.query_dispatcher.dispatch('get.cropped.doc.url', { doc_id: id })
            return res.url
        } catch (error) {
            console.error(error)
            return ''
        }
    }

    async get_original_document_url(id: any): Promise<string> {
        try {
            let res = await this.query_dispatcher.dispatch('get.original.doc.url', { doc_id: id })
            return res.url
        } catch (error) {
            console.error(error)
            return ''
        }
    }

    async find_by_id(id: any): Promise<any> {
        try {
            let res = await this.query_dispatcher.dispatch('get.document', { id: id })
            console.log(res)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async get_full_payload(id: any): Promise<any> {
        try {
            let res = await this.query_dispatcher.dispatch('get.document.full_payload', { id: id })
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async aproveDocument(id: any): Promise<any> {
        try {
            let res = await this.sync_command_dispatcher.dispatch('approve.document', { doc_id: id })
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async rejectDocument(id: any): Promise<any> {
        try {
            let res = await this.sync_command_dispatcher.dispatch('reject.document', { doc_id: id })
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async saveDocumentComments(args: any): Promise<any> {
        try {
           await this.sync_command_dispatcher.dispatch('save.document.comments', args);
        } catch (error) {
            console.error(error)
        }
    }

    async getAvailableTypes(): Promise<any> {
        try {
            let res = await this.query_dispatcher.dispatch('get.document.types', {})
            return res
        } catch (error) {
            console.error(error)
            return []
        }
    }

    async getAvailableCredits(): Promise<number> {
        try {
            let res = await this.query_dispatcher.dispatch('get.available.credits', {})
            return res.credits
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async saveDocumentTypes(types: Array<string>): Promise<any> {
        let args = { types: types }
        try {
            await this.sync_command_dispatcher.dispatch('save.document.types', args);
        } catch (error) {
            console.error(error)
        }
    }
    
    async deleteDocuments(args: any): Promise<void> {
        // let args = { document_ids: document_ids }
        try {
            await this.sync_command_dispatcher.dispatch('delete.documents', args);
        } catch (error) {
            console.error(error)
        }
    }

    async moveDocsToFolder(args: any): Promise<void> {
        try {
            await this.sync_command_dispatcher.dispatch('move.document.to.a.folder', args);
        } catch (error) {
            console.error(error)
        }
    }

    async downloadDocuments(args: any): Promise<any> {
        // let args = { doc_ids: doc_ids }
        try {
            let res = await this.async_command_dispatcher.dispatch('download.document', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async changeDocsWorkflow(args: any): Promise<any> {
        try {
            let res = await this.sync_command_dispatcher.dispatch('modify.document.workflow', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async saveFolder(args: any): Promise<any> {
        try {
            let res = await this.sync_command_dispatcher.dispatch('save.folder', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async callContinueWorkflow(args: any): Promise<any> {
        try {
            let res = await this.sync_command_dispatcher.dispatch('continue.workflow', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }
    
    async callRetryWorkflow(args: any): Promise<any> {
        try {
            let res = await this.sync_command_dispatcher.dispatch('retry.document.workflow', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }



    async getCompanyFolders(args: any): Promise<any> {
        try {
            let res = await this.query_dispatcher.dispatch('get.company.folders', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async deleteFolder(args: { uuid: string; company_id:string; delete_content: boolean;}): Promise<boolean> {
        try {
            await this.sync_command_dispatcher.dispatch('delete.folder', args);
            return true;
        } catch (error) {
            console.error("Error al mantener el contenido:", error);
            return false;
        }
    }
}

export class MemoryOtherDocumentRepository implements OtherDocumentRepository {
    documents: Array<Document> = []
    folders: Array<Folder> = []
    constructor(documents, folders) {
        this.documents = documents
        this.folders = folders
    }

    async getUserPermissions(args):Promise<{ user_role: string; permissions: string}>{
        return {
            user_role: "",
            permissions: "",
        }
    }

    async get_documents(args: any): Promise<any> {
        let company_id = args['company_id']
        let folder_uuid = args.folder_uuid
        let res = await this.documents.filter(doc => {
            if (doc.company_id != company_id) return false
            if (folder_uuid === null || folder_uuid === undefined) return true
            if (folder_uuid === '') return !doc.folder_uuid
            return doc.folder_uuid == folder_uuid
        })
        return {data: res, count: res.length}
    }

    async get_document_url(id){
        let res = this.documents.find((doc: { id: any }) => doc.id == id)
        return res['path']
    }

    async get_cropped_document_url(id: any): Promise<string> {
        let res = this.documents.find(doc => doc.id == id)
        return res['cropped_path']
    }

    async get_original_document_url(id: any): Promise<string> {
        let res = this.documents.find(doc => doc.id == id)
        return res['original_path']
    }

    async find_by_id(id: any): Promise<any> {
        let res = this.documents.find(doc => doc.id == id)
        return res
    }

    async get_full_payload(id: any): Promise<any> {
        return {}
    }

    async aproveDocument(id: any): Promise<any> {
        let res = this.documents.find(doc => doc.id == id)
        res['status'] = 'approved'
        return res
    }

    async rejectDocument(id: any): Promise<any> {
        let res = this.documents.find(doc => doc.id == id)
        res['status'] = 'rejected'
        return res
    }

    async saveDocumentComments(args: any): Promise<any> {
        this.documents.push(args)
    }

    async getAvailableTypes(): Promise<any> {
        let res = ['contract', 'bill']
        return res
    }

    async getAvailableCredits(): Promise<number> {
        return 10
    }
    
    async saveDocumentTypes(types: Array<string>): Promise<any> {
        return
    }

    async deleteDocuments(args: any): Promise<void> {
        this.documents = this.documents.filter(doc => !args.document_ids.includes(doc.id))
    }

    async downloadDocuments(args: any): Promise<any> {
        return
    }

    async changeDocsWorkflow(args: any): Promise<any> {
        let res = this.documents.find(doc => doc.id == args.doc_id)
        res['workflow'] = args.workflow
        return res
    }

    async callContinueWorkflow(args: any): Promise<any> {
        return
    }

    async callRetryWorkflow(args: any): Promise<any> {
        return
    }



    async getCompanyFolders(args: any): Promise<any> {
        const filter_folders = []

        const root_folders = this.folders.filter(folder =>
            folder.company_id == args.company_id &&
            !folder.deleted &&
            folder.parent == null
        )

        for (const folder of root_folders) {
            folder.children = [] // aseguramos array

            for (const potential_child of this.folders) {
                if (
                    potential_child.parent &&
                    potential_child.parent.uuid === folder.uuid &&
                    !potential_child.deleted &&
                    potential_child.company_id === args.company_id
                ) {
                    folder.children.push(potential_child)
                }
            }
            filter_folders.push(folder)
    }
        return filter_folders
    }

    async moveDocsToFolder(args: any): Promise<void> {
        for(const doc_id of args.doc_ids){
            let count = 0
            for(const doc of this.documents){
                if(doc_id == doc.id){
                    this.documents[count].folder_uuid = args.folder_uuid
                }
                count++
            }
        }
    }

    async saveFolder(args: any): Promise<any> {
        if(args && args["uuid"]){
            for(const folder of this.folders){
                if(folder.uuid == args["uuid"]){
                    folder.company_id = args["company_id"]
                    folder.name = args["name"]
                    folder.is_private = args["is_private"]
                    return args["uuid"]
                }
            }
        }else{
            const folder_uuid = args.name+"_uuid"
            const name = args.name
            const company_id = args.company_id
            const is_private = args.is_private

            let parent: Folder | null = null
            if(args.parent_uuid){
                parent = this.folders.find(folder => folder.uuid == args.parent_uuid) || null
            }
            const new_folder = new Folder(folder_uuid, name, company_id, is_private, parent, false)
            this.folders.push(new_folder)

            if(parent){
                parent.children.push(new_folder)
            }
            return folder_uuid
        }
    }
    
    async deleteFolder(args: any): Promise<boolean>{
        const folder = this.folders.find(f => f.uuid === args.uuid)
        if (!folder) return false

        if(args.delete_content){
            this.markAsDeletedRecursive(folder)
        }else{
            this.reassignChildrenToParent(folder)
            folder.deleted = true
        }
        return false
    }

    private markAsDeletedRecursive(folder: Folder): void {
        folder.deleted = true
        if (folder.children && folder.children.length > 0) {
            for (const child of folder.children) {
                this.markAsDeletedRecursive(child)
            }
        }
    }

    private reassignChildrenToParent(folder: Folder): void {
        for (const child of this.folders) {
            if (child.parent && child.parent.uuid === folder.uuid) {
                child.parent = folder.parent
            }
        }
    }
}